export const TASKLISTDETAIL_LOADING = "TASKLISTDETAIL_LOADING";
export const TASKLISTDETAIL_RESET = "TASKLISTDETAIL_RESET";
export const GET_TASKLISTDETAIL = "GET_TASKLISTDETAIL";
export const GET_TASKLISTDETAIL_SUCCESS = "GET_TASKLISTDETAIL_SUCCESS";
export const GET_TASKLISTDETAIL_FAIL = "GET_TASKLISTDETAIL_FAIL";
export const DELETE_TASKLISTDETAIL = "DELETE_TASKLISTDETAIL"
export const DELETE_TASKLISTDETAIL_SUCCESS = "DELETE_TASKLISTDETAIL_SUCCESS"
export const DELETE_TASKLISTDETAIL_FAIL = "DELETE_TASKLISTDETAIL_FAIL"
export const UPDATE_TASKLISTDETAIL = "UPDATE_TASKLISTDETAIL"
export const UPDATE_TASKLISTDETAIL_SUCCESS = "UPDATE_TASKLISTDETAIL_SUCCESS"
export const UPDATE_TASKLISTDETAIL_FAIL = "UPDATE_TASKLISTDETAIL_FAIL"
export const ADD_NEW_TASKLISTDETAIL = "ADD_NEW_TASKLISTDETAIL"
export const ADD_TASKLISTDETAIL_SUCCESS = "ADD_TASKLISTDETAIL_SUCCESS"
export const ADD_TASKLISTDETAIL_FAIL = "ADD_TASKLISTDETAIL_FAIL"